module.exports = {"auto":["auto - 5th car policy","motorcycle","auto"],"property":["condo","fire","home","home - secondary residence","home warranty","landlord","rent","renters"],"other":["boat","Inland Marine","pet","pumbr","rv","umbrella"]}


//////////////////
// WEBPACK FOOTER
// ./src/settings/lineOfBusiness.json
// module id = 2795
// module chunks = 0